import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
/**
 * Education Component
 */
let EducationComponent = class EducationComponent {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.httpClient.get('education').subscribe((result) => {
            this.arrayFromServer = Object.values(result);
        }, (error) => {
            console.log(error);
        });
    }
    ngOnInit() {
    }
};
EducationComponent.ctorParameters = () => [
    { type: SharedHttp }
];
EducationComponent = __decorate([
    Component({
        selector: 'ecd-education',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./education.component.html")).default
    })
], EducationComponent);
export { EducationComponent };
